import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthenticatedHomeRedirectGuard } from './core/guards/authenticated-home-redirect.guard';
import { supportPageAccessGuard } from './core/guards/support-page-access.guard';

const supportAccess = (...permissionCodes: string[]) => ({
  supportPermissions: permissionCodes,
});

export const routes: Routes = [
  {
    path: 'knowledgebase',
    loadComponent: () =>
      import('./features/landing/knowledgebase/knowledgebase').then(
        m => m.KnowledgebaseComponent
      ),
    title: 'Knowledgebase - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance',
    redirectTo:
      'knowledgebase/support-maintenance/managing-maintenance-requests',
    pathMatch: 'full',
  },
  {
    path: 'knowledgebase/support-maintenance/managing-maintenance-requests',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/maintenance/maintenance').then(
        m => m.SupportMaintenanceComponent
      ),
    title: 'Managing Maintenance Requests - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/requesting-repairs',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/requesting-repairs/requesting-repairs').then(
        m => m.RequestingRepairsComponent
      ),
    title: 'Requesting Repairs - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/requesting-repairs/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/requesting-repairs/requesting-repairs').then(
        m => m.RequestingRepairsComponent
      ),
    title: 'Requesting Repairs - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/reporting-a-bug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/reporting-bug/reporting-bug').then(
        m => m.ReportingBugComponent
      ),
    title: 'Reporting a Bug - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/reporting-a-bug/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/reporting-bug/reporting-bug').then(
        m => m.ReportingBugComponent
      ),
    title: 'Reporting a Bug - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/tenant-communication',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/tenant-communication/tenant-communication').then(
        m => m.TenantCommunicationComponent
      ),
    title: 'Tenant Communication - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/tenant-communication/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/tenant-communication/tenant-communication').then(
        m => m.TenantCommunicationComponent
      ),
    title: 'Tenant Communication - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/support-ticket-tracking',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/support-ticket-tracking/support-ticket-tracking').then(
        m => m.SupportTicketTrackingComponent
      ),
    title: 'Support Ticket Tracking - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/support-ticket-tracking/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/support-ticket-tracking/support-ticket-tracking').then(
        m => m.SupportTicketTrackingComponent
      ),
    title: 'Support Ticket Tracking - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/faqs',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/faqs/faqs').then(
        m => m.SupportMaintenanceFaqsComponent
      ),
    title: 'Support & Maintenance FAQs - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/faqs/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/faqs/faqs').then(
        m => m.SupportMaintenanceFaqsComponent
      ),
    title: 'Support & Maintenance FAQs - RMA',
  },
  {
    path: 'knowledgebase/support-maintenance/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/support-maintenance/maintenance/maintenance').then(
        m => m.SupportMaintenanceComponent
      ),
    title: 'Support & Maintenance - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents',
    redirectTo: 'knowledgebase/leasing-documents/lease-agreements',
    pathMatch: 'full',
  },
  {
    path: 'knowledgebase/leasing-documents/lease-agreements',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/lease-agreements/lease-agreements').then(
        m => m.LeaseAgreementsHelpComponent
      ),
    title: 'Lease Agreements - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/lease-agreements/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/lease-agreements/lease-agreements').then(
        m => m.LeaseAgreementsHelpComponent
      ),
    title: 'Lease Agreements - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/document-uploads',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/document-uploads/document-uploads').then(
        m => m.DocumentUploadsHelpComponent
      ),
    title: 'Document Uploads - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/document-uploads/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/document-uploads/document-uploads').then(
        m => m.DocumentUploadsHelpComponent
      ),
    title: 'Document Uploads - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/digital-signatures',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/digital-signatures/digital-signatures').then(
        m => m.DigitalSignaturesHelpComponent
      ),
    title: 'Digital Signatures - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/digital-signatures/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/digital-signatures/digital-signatures').then(
        m => m.DigitalSignaturesHelpComponent
      ),
    title: 'Digital Signatures - RMA',
  },
  {
    path: 'knowledgebase/payments-financials',
    redirectTo: 'knowledgebase/payments-financials/online-payments',
    pathMatch: 'full',
  },
  {
    path: 'knowledgebase/payments-financials/online-payments',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/online-payments/online-payments').then(
        m => m.OnlinePaymentsHelpComponent
      ),
    title: 'Online Payments - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/online-payments/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/online-payments/online-payments').then(
        m => m.OnlinePaymentsHelpComponent
      ),
    title: 'Online Payments - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/security-deposits',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/security-deposits/security-deposits').then(
        m => m.SecurityDepositsHelpComponent
      ),
    title: 'Security Deposits - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/security-deposits/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/security-deposits/security-deposits').then(
        m => m.SecurityDepositsHelpComponent
      ),
    title: 'Security Deposits - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/payment-history',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/payment-history/payment-history').then(
        m => m.PaymentHistoryHelpComponent
      ),
    title: 'Payment History - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/payment-history/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/payment-history/payment-history').then(
        m => m.PaymentHistoryHelpComponent
      ),
    title: 'Payment History - RMA',
  },
  {
    path: 'knowledgebase/reports',
    redirectTo: 'knowledgebase/reports/financial-reports',
    pathMatch: 'full',
  },
  {
    path: 'knowledgebase/reports/financial-reports',
    loadComponent: () =>
      import('./features/landing/help-pages/reports/financial-reports/financial-reports').then(
        m => m.FinancialReportsHelpComponent
      ),
    title: 'Financial Reports - RMA',
  },
  {
    path: 'knowledgebase/reports/financial-reports/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/reports/financial-reports/financial-reports').then(
        m => m.FinancialReportsHelpComponent
      ),
    title: 'Financial Reports - RMA',
  },
  {
    path: 'knowledgebase/reports/exports',
    loadComponent: () =>
      import('./features/landing/help-pages/reports/exports/exports').then(
        m => m.ReportsExportsHelpComponent
      ),
    title: 'Exports & Sharing - RMA',
  },
  {
    path: 'knowledgebase/reports/exports/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/reports/exports/exports').then(
        m => m.ReportsExportsHelpComponent
      ),
    title: 'Exports & Sharing - RMA',
  },
  {
    path: 'knowledgebase/notifications',
    redirectTo: 'knowledgebase/notifications/preferences',
    pathMatch: 'full',
  },
  {
    path: 'knowledgebase/notifications/preferences',
    loadComponent: () =>
      import('./features/landing/help-pages/notifications/preferences/preferences').then(
        m => m.NotificationPreferencesHelpComponent
      ),
    title: 'Notification Preferences - RMA',
  },
  {
    path: 'knowledgebase/notifications/preferences/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/notifications/preferences/preferences').then(
        m => m.NotificationPreferencesHelpComponent
      ),
    title: 'Notification Preferences - RMA',
  },
  {
    path: 'knowledgebase/notifications/payment-reminders',
    loadComponent: () =>
      import('./features/landing/help-pages/notifications/payment-reminders/payment-reminders').then(
        m => m.PaymentRemindersHelpComponent
      ),
    title: 'Payment Reminders - RMA',
  },
  {
    path: 'knowledgebase/notifications/payment-reminders/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/notifications/payment-reminders/payment-reminders').then(
        m => m.PaymentRemindersHelpComponent
      ),
    title: 'Payment Reminders - RMA',
  },
  {
    path: 'knowledgebase/notifications/maintenance-updates',
    loadComponent: () =>
      import('./features/landing/help-pages/notifications/maintenance-updates/maintenance-updates').then(
        m => m.MaintenanceUpdatesHelpComponent
      ),
    title: 'Maintenance Updates - RMA',
  },
  {
    path: 'knowledgebase/notifications/maintenance-updates/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/notifications/maintenance-updates/maintenance-updates').then(
        m => m.MaintenanceUpdatesHelpComponent
      ),
    title: 'Maintenance Updates - RMA',
  },
  {
    path: 'knowledgebase/referrals',
    redirectTo: 'knowledgebase/referrals/referral-program',
    pathMatch: 'full',
  },
  {
    path: 'knowledgebase/referrals/referral-program',
    loadComponent: () =>
      import('./features/landing/help-pages/referrals/referral-program/referral-program').then(
        m => m.ReferralProgramHelpComponent
      ),
    title: 'Referral Program - RMA',
  },
  {
    path: 'knowledgebase/referrals/referral-program/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/referrals/referral-program/referral-program').then(
        m => m.ReferralProgramHelpComponent
      ),
    title: 'Referral Program - RMA',
  },
  {
    path: 'knowledgebase/referrals/share-invite-link',
    loadComponent: () =>
      import('./features/landing/help-pages/referrals/share-invite-link/share-invite-link').then(
        m => m.ShareInviteLinkHelpComponent
      ),
    title: 'Share Invite Link - RMA',
  },
  {
    path: 'knowledgebase/referrals/share-invite-link/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/referrals/share-invite-link/share-invite-link').then(
        m => m.ShareInviteLinkHelpComponent
      ),
    title: 'Share Invite Link - RMA',
  },
  {
    path: 'knowledgebase/referrals/track-referrals',
    loadComponent: () =>
      import('./features/landing/help-pages/referrals/track-referrals/track-referrals').then(
        m => m.TrackReferralsHelpComponent
      ),
    title: 'Track Referrals - RMA',
  },
  {
    path: 'knowledgebase/referrals/track-referrals/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/referrals/track-referrals/track-referrals').then(
        m => m.TrackReferralsHelpComponent
      ),
    title: 'Track Referrals - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/application-reviews',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/application-review/review').then(
        m => m.ApplicationReviewsHelpComponent
      ),
    title: 'Application Reviews - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/application-reviews/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/application-review/review').then(
        m => m.ApplicationReviewsHelpComponent
      ),
    title: 'Application Reviews - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/property-listings',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/property-listings/property-listings').then(
        m => m.PropertyListingsHelpComponent
      ),
    title: 'Property Listings - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/property-listings/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/property-listings/property-listings').then(
        m => m.PropertyListingsHelpComponent
      ),
    title: 'Property Listings - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/tenant-screening',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/tenant-screening/tenant-screening').then(
        m => m.TenantScreeningHelpComponent
      ),
    title: 'Tenant Screening - RMA',
  },
  {
    path: 'knowledgebase/leasing-documents/tenant-screening/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/leasing-documents/tenant-screening/tenant-screening').then(
        m => m.TenantScreeningHelpComponent
      ),
    title: 'Tenant Screening - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/late-fees',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/late-fees/late-fees').then(
        m => m.LateFeesHelpComponent
      ),
    title: 'Late Fees - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/late-fees/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/late-fees/late-fees').then(
        m => m.LateFeesHelpComponent
      ),
    title: 'Late Fees - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/invoices-billing',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/invoices-billing/invoices-billing').then(
        m => m.InvoicesBillingHelpComponent
      ),
    title: 'Invoices & Billing - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/invoices-billing/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/invoices-billing/invoices-billing').then(
        m => m.InvoicesBillingHelpComponent
      ),
    title: 'Invoices & Billing - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/owner-statements',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/owner-statements/owner-statements').then(
        m => m.OwnerStatementsHelpComponent
      ),
    title: 'Owner Statements - RMA',
  },
  {
    path: 'knowledgebase/payments-financials/owner-statements/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/payments-financials/owner-statements/owner-statements').then(
        m => m.OwnerStatementsHelpComponent
      ),
    title: 'Owner Statements - RMA',
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./features/landing/contact-us/contact-us').then(
        m => m.ContactUsComponent
      ),
  },

  // Token Display Names route moved under dashboard/super-admin/configuration for correct layout
  // Stepper route moved under dashboard/landlord for consistent layout
  {
    path: 'why-rentals',
    loadComponent: () =>
      import('./features/landing/rentals/why-rentals').then(
        m => m.WhyRentalsComponent
      ),
    title: 'Why Rentals - RMA',
  },
  {
    path: 'data-security',
    loadComponent: () =>
      import('./features/landing/data-security/data-security').then(
        m => m.DataSecurityComponent
      ),
    title: 'Data Security - RMA',
  },
  {
    path: 'popular-blogs',
    loadComponent: () =>
      import('./features/landing/popular-blogs/popular-blogs').then(
        m => m.PopularBlogsComponent
      ),
    title: 'Popular Blogs - RMA',
  },
  {
    path: 'popular-blogs/:slug',
    loadComponent: () =>
      import('./features/landing/popular-blogs/blog-article').then(
        m => m.BlogArticleComponent
      ),
    title: 'RMA Blog',
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/landing/privacy/policy').then(
        m => m.PrivacyPolicyComponent
      ),
    title: 'Privacy Policy',
  },
  {
    path: 'cookie-policy',
    loadComponent: () =>
      import('./features/landing/cookie-policy/cookie-policy').then(
        m => m.CookiePolicyComponent
      ),
    title: 'Cookie Policy - RMA',
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./features/landing/terms/terms').then(
        m => m.TermsAndConditionsComponent
      ),
    title: 'Terms & Conditions - RMA',
  },
  {
    path: 'help-center',
    loadComponent: () =>
      import('./features/landing/help-center/help').then(
        m => m.HelpCenterComponent
      ),
    title: 'Help Center - RMA',
  },
  {
    path: 'help-center/getting-started/landlord',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/start-as-landlord/start').then(
        m => m.StartAsLandlordComponent
      ),
    title: 'Getting Started as a Landlord - RMA',
  },
  {
    path: 'help-center/getting-started/landlord/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/start-as-landlord/start').then(
        m => m.StartAsLandlordComponent
      ),
    title: 'Getting Started as a Landlord - RMA',
  },
  {
    path: 'help-center/getting-started/search-properties',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/search-properties/search').then(
        m => m.SearchPropertiesComponent
      ),
    title: 'Searching for Rental Properties - RMA',
  },
  {
    path: 'help-center/getting-started/search-properties/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/search-properties/search').then(
        m => m.SearchPropertiesComponent
      ),
    title: 'Searching for Rental Properties - RMA',
  },
  {
    path: 'help-center/getting-started/account-setup',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/account-setup/account').then(
        m => m.AccountSetupHelpComponent
      ),
    title: 'Account Setup & Billing - RMA',
  },
  {
    path: 'help-center/getting-started/account-setup/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/account-setup/account').then(
        m => m.AccountSetupHelpComponent
      ),
    title: 'Account Setup & Billing - RMA',
  },
  {
    path: 'help-center/getting-started/rent-collection',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/rent-collection/rent').then(
        m => m.RentCollectionHelpComponent
      ),
    title: 'Rent Collection - RMA',
  },
  {
    path: 'help-center/getting-started/rent-collection/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/rent-collection/rent').then(
        m => m.RentCollectionHelpComponent
      ),
    title: 'Rent Collection - RMA',
  },
  {
    path: 'help-center/getting-started/payrent-online',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/payrent-online/pay').then(
        m => m.PayrentOnlineHelpComponent
      ),
    title: 'Paying Rent Online - RMA',
  },
  {
    path: 'help-center/getting-started/payrent-online/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/payrent-online/pay').then(
        m => m.PayrentOnlineHelpComponent
      ),
    title: 'Paying Rent Online - RMA',
  },
  {
    path: 'help-center/getting-started/submit-application',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/submit-application/application').then(
        m => m.SubmitApplicationHelpComponent
      ),
    title: 'Submitting Rental Applications - RMA',
  },
  {
    path: 'help-center/getting-started/submit-application/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/submit-application/application').then(
        m => m.SubmitApplicationHelpComponent
      ),
    title: 'Submitting Rental Applications - RMA',
  },

  {
    path: 'help-center/getting-started/inviting-tenants',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/inviting-tenants/invite').then(
        m => m.InvitingTenantsHelpComponent
      ),
    title: 'Inviting Tenants - RMA',
  },
  {
    path: 'help-center/getting-started/inviting-tenants/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/inviting-tenants/invite').then(
        m => m.InvitingTenantsHelpComponent
      ),
    title: 'Inviting Tenants - RMA',
  },
  {
    path: 'help-center/getting-started/password-reset',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/password-reset/reset').then(
        m => m.PasswordResetHelpComponent
      ),
    title: 'Resetting Your Password - RMA',
  },
  {
    path: 'help-center/getting-started/password-reset/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/password-reset/reset').then(
        m => m.PasswordResetHelpComponent
      ),
    title: 'Resetting Your Password - RMA',
  },
  {
    path: 'help-center/getting-started/apply-property',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/apply-property/apply').then(
        m => m.ApplyPropertyHelpComponent
      ),
    title: 'Applying for a Rental - RMA',
  },
  {
    path: 'help-center/getting-started/apply-property/:articleSlug',
    loadComponent: () =>
      import('./features/landing/help-pages/getting-started/apply-property/apply').then(
        m => m.ApplyPropertyHelpComponent
      ),
    title: 'Applying for a Rental - RMA',
  },
  {
    path: 'styleguide',
    loadComponent: () =>
      import('./features/landing/dev-styleguide/styleguide').then(
        m => m.DeveloperStyleguideComponent
      ),
    title: 'Developer Styleguide - RMA',
  },
  {
    path: '',
    canActivate: [AuthenticatedHomeRedirectGuard],
    loadComponent: () =>
      import('./features/landing/landing').then(m => m.LandingComponent),
    title: 'RMA - Property Management',
  },
  {
    path: 'available-properties',
    loadComponent: () =>
      import('./features/landing/available-properties/available-properties').then(
        m => m.AvailablePropertiesComponent
      ),
    title: 'Available Properties - RMA',
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./features/support-ticket/support-ticket').then(
        m => m.SupportTicketPageComponent
      ),
    title: 'Contact Support - RMA',
  },
  {
    path: 'rma-features',
    loadComponent: () =>
      import('./features/landing/rma-features/rma-features').then(
        m => m.RMAFeaturesComponent
      ),
    title: 'RMA Features',
  },
  {
    path: 'landlord-features',
    loadComponent: () =>
      import('./features/landing/landlord-features/features').then(
        m => m.LandlordFeaturesComponent
      ),
    title: 'RMA - Landlord Features',
  },
  {
    path: 'property-manager-features',
    loadComponent: () =>
      import('./features/landing/property-manager-features/property-manager-features').then(
        m => m.PropertyManagerFeaturesComponent
      ),
    title: 'RMA - Property Manager Features',
  },
  {
    path: 'finance-analytics',
    loadComponent: () =>
      import('./features/landing/finance-analytics/finance-analytics').then(
        m => m.FinanceAnalyticsComponent
      ),
    title: 'RMA - Finance & Analytics',
  },
  {
    path: 'tenant-features',
    loadComponent: () =>
      import('./features/landing/tenant-features/features').then(
        m => m.TenantFeaturesComponent
      ),
    title: 'RMA - Tenant Features',
  },
  {
    path: 'pricing',
    loadComponent: () =>
      import('./features/landing/pricing/pricing').then(
        m => m.PricingComponent
      ),
    title: 'RMA - Pricing Plans',
  },
  {
    path: 'tools',
    loadComponent: () =>
      import('./features/landing/tools/free-tools-listing/free-tools-listing').then(
        m => m.FreeToolsListingComponent
      ),
    title: 'Free Tools - RMA',
  },
  {
    path: 'tools/tenant-rights',
    redirectTo: 'tools/tenant-rights-by-state',
    pathMatch: 'full',
  },
  {
    path: 'tools/tenant-rights/:stateSlug',
    redirectTo: 'tools/tenant-rights-by-state/:stateSlug',
    pathMatch: 'full',
  },
  {
    path: 'tools/security-deposit-limit',
    loadComponent: () =>
      import('./features/landing/tools/security-deposit-limit/security-deposit-limit').then(
        m => m.SecurityDepositLimitComponent
      ),
    title: 'Security Deposit Calculator - RMA',
  },
  {
    path: 'tools/late-fee-checker',
    loadComponent: () =>
      import('./features/landing/tools/late-fee-checker/late-fee-checker').then(
        m => m.LateFeeCheckerComponent
      ),
    title: 'Late Fee Legality Checker - RMA',
  },
  {
    path: 'tools/eviction-notice',
    loadComponent: () =>
      import('./features/landing/tools/eviction-notice/eviction-notice').then(
        m => m.EvictionNoticeComponent
      ),
    title: 'Eviction Notice Generator - RMA',
  },
  {
    path: 'tools/eviction-notice/:stateSlug',
    loadComponent: () =>
      import('./features/landing/tools/eviction-notice/eviction-notice').then(
        m => m.EvictionNoticeComponent
      ),
    title: 'Eviction Notice Generator - RMA',
  },
  {
    path: 'tools/notice-to-vacate',
    redirectTo: 'tools/eviction-notice',
    pathMatch: 'full',
  },
  {
    path: 'tools/notice-to-vacate/:stateSlug',
    redirectTo: 'tools/eviction-notice/:stateSlug',
    pathMatch: 'full',
  },
  {
    path: 'tools/tenant-rights-by-state',
    loadComponent: () =>
      import('./features/landing/tools/tenant-rights-by-state/tenant-rights-by-state-hub').then(
        m => m.TenantRightsStateHubComponent
      ),
    title: 'Tenant Rights By State - RMA',
  },
  {
    path: 'tools/tenant-rights-by-state/:stateCode',
    loadComponent: () =>
      import('./features/landing/tools/tenant-rights-by-state/tenant-rights-by-state-detail').then(
        m => m.TenantRightsStateDetailComponent
      ),
    title: 'Tenant Rights By State - RMA',
  },
  {
    path: 'tools/rent-estimate',
    loadComponent: () =>
      import('./features/landing/tools/rent-estimate/rent-estimate').then(
        m => m.RentEstimateComponent
      ),
    title: 'Rent Estimate by ZIP - RMA',
  },
  {
    path: 'tools/cap-rate-calculator',
    loadComponent: () =>
      import('./features/landing/tools/cap-rate/cap-rate.component').then(
        m => m.CapRateComponent
      ),
    title: 'Cap Rate Calculator - RMA',
  },
  {
    path: 'tools/:documentTypeSlug',
    loadComponent: () =>
      import('./features/landing/tools/free-tool-template/free-tool-template').then(
        m => m.FreeToolTemplateComponent
      ),
    title: 'Free Tool Generator - RMA',
  },
  {
    path: 'pet-friendly',
    loadComponent: () =>
      import('./features/landing/pet-friendly/pet-friendly').then(
        m => m.PetFriendlyComponent
      ),
    title: 'RMA - Pet Friendly',
  },
  {
    path: 'resident-responsibilities',
    loadComponent: () =>
      import('./features/landing/resident-responsibilities/resident-responsibilities').then(
        m => m.ResidentResponsibilitiesComponent
      ),
    title: 'RMA - Resident Responsibilities',
  },
  {
    path: 'fraud-prevention',
    loadComponent: () =>
      import('./features/landing/fraud-prevention/fraud-prevention').then(
        m => m.FraudPreventionComponent
      ),
    title: 'RMA - Fraud Prevention',
  },
  {
    path: 'search-property',
    loadComponent: () =>
      import('./features/landing/search-property/search-property').then(
        m => m.SearchPropertyComponent
      ),
    title: 'RMA - Search Property',
  },
  {
    path: 'developer-policy',
    loadComponent: () =>
      import('./features/landing/developer-policy/developer-policy').then(
        m => m.DeveloperPolicyComponent
      ),
    title: 'Developer Policy - RMA',
  },
  {
    path: 'testimonials',
    loadComponent: () =>
      import('./features/landing/testimonials/testimonials').then(
        m => m.LandingTestimonialsComponent
      ),
    title: 'Testimonials - RMA',
  },
  {
    path: 'add-testimonial',
    loadComponent: () =>
      import('./features/landing/testimonial-submit/testimonial-submit').then(
        m => m.TestimonialSubmitComponent
      ),
    title: 'Give Testimonial - RMA',
  },
  {
    path: 'reviews',
    loadComponent: () =>
      import('./features/landing/reviews/reviews').then(
        m => m.LandingReviewsComponent
      ),
    title: 'Reviews - RMA',
  },
  {
    path: 'add-review',
    loadComponent: () =>
      import('./features/landing/review-submit/review-submit').then(
        m => m.ReviewSubmitComponent
      ),
    title: 'Give Review - RMA',
  },
  {
    path: 'careers/apply/:careerId',
    loadComponent: () =>
      import('./features/landing/career-application/career-application').then(
        m => m.CareerApplicationComponent
      ),
    title: 'Apply - RMA Careers',
  },
  {
    path: 'careers',
    loadComponent: () =>
      import('./features/landing/careers/careers').then(
        m => m.LandingCareersComponent
      ),
    title: 'Careers - RMA',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/landing/landing').then(m => m.LandingComponent),
    title: 'RMA - Property Management',
  },
  {
    path: 'tenants',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'all',
        loadComponent: () =>
          import('./features/landlord/tenants/all-tenants/all-tenants').then(
            m => m.AllTenantsComponent
          ),
        title: 'All Tenants',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/authentication/login/login').then(
            m => m.AuthLoginComponent
          ),
        title: 'Login',
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./features/authentication/register/register').then(
            m => m.AuthRegisterComponent
          ),
        title: 'Sign Up',
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/authentication/login/login').then(
        m => m.AuthLoginComponent
      ),
    title: 'Login',
  },
  {
    path: 'support/login',
    loadComponent: () =>
      import('./features/authentication/support-login/support-login').then(
        m => m.SupportLoginComponent
      ),
    title: 'Support Login',
    data: {
      allowedRoles: ['support'],
      loginTitle: 'Support Sign In',
      loginSubtitle: 'Sign in to access the Support dashboard',
      loginNotice: 'This login page is only for Support users.',
    },
  },
  {
    path: 'super-admin/login',
    loadComponent: () =>
      import('./features/authentication/support-login/support-login').then(
        m => m.SupportLoginComponent
      ),
    title: 'Super Admin Login',
    data: {
      allowedRoles: ['super_admin'],
      loginTitle: 'Super Admin Sign In',
      loginSubtitle: 'Sign in to access the Super Admin dashboard',
      loginNotice: 'This login page is only for Super Admin users.',
    },
  },
  {
    path: 'admin/login',
    loadComponent: () =>
      import('./features/authentication/support-login/support-login').then(
        m => m.SupportLoginComponent
      ),
    title: 'Admin Login',
    data: {
      allowedRoles: ['admin'],
      loginTitle: 'Admin Sign In',
      loginSubtitle: 'Sign in to access the Admin dashboard',
      loginNotice: 'This login page is only for Admin users.',
    },
  },
  {
    path: 'Admin/login',
    redirectTo: 'admin/login',
    pathMatch: 'full',
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/authentication/register/register').then(
        m => m.AuthRegisterComponent
      ),
    title: 'Sign Up',
  },
  {
    path: 'ref/:code',
    loadComponent: () =>
      import('./features/referral/entry').then(m => m.ReferralEntryComponent),
    title: 'Referral Redirect',
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/authentication/forgot-password/forgot-password').then(
        m => m.ForgotPasswordComponent
      ),
    title: 'Forgot Password',
  },
  // Alias for backend-generated resetPassword link
  {
    path: 'resetPassword/:id/:token',
    loadComponent: () =>
      import('./features/authentication/reset-password/reset-password').then(
        m => m.ResetPasswordComponent
      ),
    title: 'Reset Password',
  },
  {
    path: 'reset-password/:id/:token',
    loadComponent: () =>
      import('./features/authentication/reset-password/reset-password').then(
        m => m.ResetPasswordComponent
      ),
    title: 'Reset Password',
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'admin',
        loadComponent: () =>
          import('./shared/layout/generic/generic-layout.component').then(
            m => m.GenericLayoutComponent
          ),
        title: 'Admin Portal',
        data: { role: 'admin' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/dashboard/admin/admin').then(
                m => m.AdminDashboardComponent
              ),
            title: 'Admin Dashboard',
          },
        ],
      },
      {
        path: 'super-admin',
        loadComponent: () =>
          import('./shared/layout/generic/generic-layout.component').then(
            m => m.GenericLayoutComponent
          ),
        title: 'Super Admin Portal',
        data: { role: 'super-admin' },
        canActivateChild: [supportPageAccessGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/dashboard/super-admin/super-admin-dashboard').then(
                m => m.SuperAdminDashboardComponent
              ),
            title: 'Super Admin Dashboard',
            data: supportAccess('superadmin.view.dashboard'),
          },
          {
            path: 'messages',
            loadComponent: () =>
              import('./features/super-admin/messages/messages').then(
                m => m.SuperAdminMessagesComponent
              ),
            title: 'Messages',
            data: supportAccess('admin.overview.view'),
          },
          {
            path: 'reviews',
            loadComponent: () =>
              import('./features/reviews/reviews').then(
                m => m.ReviewsComponent
              ),
            title: 'All Reviews',
            data: {
              reviewMode: 'super-admin',
              ...supportAccess('admin.overview.view'),
            },
          },
          {
            path: 'testimonials',
            loadComponent: () =>
              import('./features/testimonials/testimonials').then(
                m => m.TestimonialsComponent
              ),
            title: 'All Testimonials',
            data: {
              testimonialMode: 'super-admin',
              ...supportAccess('admin.overview.view'),
            },
          },
          {
            path: 'careers',
            loadComponent: () =>
              import('./features/careers/careers').then(
                m => m.CareersComponent
              ),
            title: 'Careers',
            data: supportAccess('admin.overview.view'),
          },
          {
            path: 'referral',
            loadComponent: () =>
              import('./features/super-admin/referral-programs/referral-programs').then(
                m => m.ReferralProgramsComponent
              ),
            title: 'Referral Programs',
            data: supportAccess('admin.overview.view'),
          },
          {
            path: 'referrals/all',
            loadComponent: () =>
              import('./features/super-admin/all-referrals/all-referrals').then(
                m => m.AllReferralsComponent
              ),
            title: 'All Referrals',
            data: supportAccess('admin.overview.view'),
          },
          {
            path: 'referrals/expiry',
            loadComponent: () =>
              import('./features/super-admin/referral-expiry/referral-expiry').then(
                m => m.ReferralExpiryComponent
              ),
            title: 'Referral Expiry Configuration',
          },
          {
            path: 'referrals/is-features',
            loadComponent: () =>
              import('./features/super-admin/referral-is-features/referral-is-features').then(
                m => m.ReferralIsFeaturesComponent
              ),
            title: 'Is Features',
            data: supportAccess('admin.overview.view'),
          },
          {
            path: 'mailbox',
            loadComponent: () =>
              import('./features/mailbox/mailbox').then(
                m => m.MailboxComponent
              ),
            title: 'Mailbox',
            data: supportAccess('admin.overview.view'),
          },
          // Super Admin Reports
          {
            path: 'reports/net-cash-flow',
            loadComponent: () =>
              import('./features/landlord/reports/net-cash-flow/net-cash-flow').then(
                m => m.NetCashFlowComponent
              ),
            title: 'Net Cash Flow Report',
          },
          {
            path: 'reports/income-statement',
            loadComponent: () =>
              import('./features/landlord/reports/income-statement/income-statement').then(
                m => m.IncomeStatementComponent
              ),
            title: 'Income Statement Report',
          },
          {
            path: 'reports/general-ledger',
            loadComponent: () =>
              import('./features/landlord/reports/general-ledger/general-ledger').then(
                m => m.GeneralLedgerComponent
              ),
            title: 'General Ledger Report',
          },
          {
            path: 'reports/financial-reports',
            loadComponent: () =>
              import('./features/landlord/reports/financial-reports/financial-reports').then(
                m => m.FinancialReportsComponent
              ),
            title: 'Financial Reports',
          },
          {
            path: 'reports/maintenance',
            loadComponent: () =>
              import('./features/landlord/reports/maintenance/maintenance').then(
                m => m.MaintenanceReportsComponent
              ),
            title: 'Maintenance Reports',
          },
          {
            path: 'reports/occupancy',
            loadComponent: () =>
              import('./features/landlord/reports/occupancy/occupancy').then(
                m => m.OccupancyReportsComponent
              ),
            title: 'Occupancy Reports',
          },
          {
            path: 'admin/overview',
            loadComponent: () =>
              import('./features/super-admin/overview/overview').then(
                m => m.SuperAdminOverviewComponent
              ),
            title: 'Overview',
            data: supportAccess('admin.overview.view'),
          },
          {
            path: 'admin/users',
            loadComponent: () =>
              import('./features/super-admin/user-management/user-management.component').then(
                m => m.UserManagementComponent
              ),
            title: 'User Management',
            data: supportAccess('admin.users.view.all'),
          },
          {
            path: 'admin/users/add',
            loadComponent: () =>
              import('./features/super-admin/user-add/user-add.component').then(
                m => m.UserAddComponent
              ),
            title: 'Add User',
            data: supportAccess('admin.users.create'),
          },
          {
            path: 'admin/roles',
            loadComponent: () =>
              import('./features/super-admin/user-roles/user-roles.component').then(
                m => m.UserRolesComponent
              ),
            title: 'User Roles',
            data: supportAccess('admin.roles.manage'),
          },
          {
            path: 'admin/roles/create',
            loadComponent: () =>
              import('./features/super-admin/role-create/role-create.component').then(
                m => m.RoleCreateComponent
              ),
            title: 'Create Role',
          },
          {
            path: 'admin/roles/edit/:id',
            loadComponent: () =>
              import('./features/super-admin/role-create/role-create.component').then(
                m => m.RoleCreateComponent
              ),
            title: 'Edit Role',
          },
          {
            path: 'admin/property-types',
            loadComponent: () =>
              import('./features/super-admin/property-types/property-types.component').then(
                m => m.PropertyTypesComponent
              ),
            title: 'Property Types Management',
            data: supportAccess('admin.property_types.manage'),
          },
          {
            path: 'admin/document-types',
            loadComponent: () =>
              import('./features/super-admin/document-types/document-types').then(
                m => m.DocumentTypesComponent
              ),
            title: 'Document Types Management',
            data: supportAccess('superadmin.manage.documnent_types'),
          },
          {
            path: 'admin/document-types/add',
            loadComponent: () =>
              import('./features/super-admin/document-type-form/document-type-form.component').then(
                m => m.DocumentTypeFormComponent
              ),
            title: 'Add Document Type',
          },
          {
            path: 'admin/document-types/edit/:id',
            loadComponent: () =>
              import('./features/super-admin/document-type-form/document-type-form.component').then(
                m => m.DocumentTypeFormComponent
              ),
            title: 'Edit Document Type',
          },
          {
            path: 'admin/property-types/add',
            loadComponent: () =>
              import('./features/super-admin/property-type-form/property-type-form.component').then(
                m => m.PropertyTypeFormComponent
              ),
            title: 'Add Property Type',
          },
          {
            path: 'admin/property-types/edit/:id',
            loadComponent: () =>
              import('./features/super-admin/property-type-form/property-type-form.component').then(
                m => m.PropertyTypeFormComponent
              ),
            title: 'Edit Property Type',
          },
          {
            path: 'admin/lease-types',
            loadComponent: () =>
              import('./features/super-admin/lease-types/lease-types.component').then(
                m => m.LeaseTypesComponent
              ),
            title: 'Lease Types Management',
            data: supportAccess('admin.lease_types.manage'),
          },
          {
            path: 'leases/all',
            loadComponent: () =>
              import('./features/super-admin/leases/all-leases/all-leases').then(
                m => m.AllLeasesComponent
              ),
            title: 'All Leases',
            data: supportAccess('leases.view.all'),
          },
          {
            path: 'leases/active',
            loadComponent: () =>
              import('./features/super-admin/leases/active-leases/active-leases').then(
                m => m.ActiveLeasesComponent
              ),
            title: 'Active Leases',
            data: supportAccess('leases.view.active'),
          },
          {
            path: 'leases/expiring',
            loadComponent: () =>
              import('./features/super-admin/leases/expire-leases/expire-leases').then(
                m => m.ExpireLeasesComponent
              ),
            title: 'Expiring & Expired Leases',
            data: supportAccess('leases.view.expiring'),
          },
          // TODO: Uncomment when lease-type-form component is created
          // {
          //   path: 'admin/lease-types/add',
          //   loadComponent: () =>
          //     import('./features/super-admin/lease-type-form/lease-type-form.component').then(m => m.LeaseTypeFormComponent),
          //   title: 'Add Lease Type'
          // },
          // {
          //   path: 'admin/lease-types/edit/:id',
          //   loadComponent: () =>
          //     import('./features/super-admin/lease-type-form/lease-type-form.component').then(m => m.LeaseTypeFormComponent),
          //   title: 'Edit Lease Type'
          // },
          {
            path: 'landlords',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/super-admin/landlords/landlords').then(
                    m => m.SuperAdminLandlordsComponent
                  ),
                title: 'Landlord Management',
              },
              {
                path: 'all',
                loadComponent: () =>
                  import('./features/super-admin/landlords/all-landlords').then(
                    m => m.AllLandlordsComponent
                  ),
                title: 'All Landlords',
                data: supportAccess('landlords.view.all'),
              },
              {
                path: 'add',
                loadComponent: () =>
                  import('./features/super-admin/user-add/user-add.component').then(
                    m => m.UserAddComponent
                  ),
                title: 'Add Landlord',
                data: supportAccess('landlords.create'),
              },
              {
                path: 'applications',
                loadComponent: () =>
                  import('./features/super-admin/landlords/applications/applications').then(
                    m => m.ApplicationsComponent
                  ),
                title: 'Landlord Applications',
                data: supportAccess('landlords.applications.view'),
              },
            ],
          },
          {
            path: 'property-managers',
            loadComponent: () =>
              import('./features/super-admin/property-managers/all-property-managers').then(
                m => m.AllPropertyManagersComponent
              ),
            title: 'All Property Managers',
          },
          {
            path: 'tenants',
            loadComponent: () =>
              import('./features/super-admin/tenants/tenants').then(
                m => m.SuperAdminTenantsComponent
              ),
            title: 'Tenant Management',
          },
          {
            path: 'profile',
            loadComponent: () =>
              import('./features/profile/profile').then(
                m => m.UserProfileComponent
              ),
            title: 'Profile',
            data: supportAccess('profile.edit.own'),
          },
          {
            path: 'settings',
            children: [
              {
                path: 'profile',
                loadComponent: () =>
                  import('./features/profile/profile').then(
                    m => m.UserProfileComponent
                  ),
                title: 'Profile Settings',
              },
              {
                path: 'display',
                loadComponent: () =>
                  import('./features/super-admin/settings/display/display').then(
                    m => m.DisplayComponent
                  ),
                title: 'Display Settings',
                data: supportAccess('settings.display.edit'),
              },
              {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'app-version',
            loadComponent: () =>
              import('./features/super-admin/app-version/app-version').then(
                m => m.AppVersionComponent
              ),
            title: 'App Version',
            data: supportAccess('settings.display.edit'),
          },
          {
            path: 'app-releases',
            loadComponent: () =>
              import('./features/super-admin/app-releases/app-releases').then(
                m => m.AppReleasesComponent
              ),
            title: 'App Releases',
            data: supportAccess('settings.display.edit'),
          },
          {
            path: 'payments/all',
            loadComponent: () =>
              import('./features/super-admin/payments/all/all-payments').then(
                m => m.AllPaymentsComponent
              ),
            title: 'All Payments',
            data: supportAccess('payments.view.all'),
          },
          {
            path: 'payments/payout',
            loadComponent: () =>
              import('./features/super-admin/payments/payout/payout').then(
                m => m.PaymentPayoutComponent
              ),
            title: 'Payout History',
            data: supportAccess('payments.view.payout'),
          },
          {
            path: 'configuration/payments',
            loadComponent: () =>
              import('./features/super-admin/configuration/payments/payments').then(
                m => m.PaymentsComponent
              ),
            title: 'Payment Configuration',
            data: supportAccess('config.payments.manage'),
          },
          {
            path: 'configuration/payout',
            loadComponent: () =>
              import('./features/super-admin/configuration/payout/payout').then(
                m => m.PayoutComponent
              ),
            title: 'Payout Configuration',
            data: supportAccess('payout.manage.config'),
          },
          {
            path: 'configuration/database',
            loadComponent: () =>
              import('./features/super-admin/configuration/database/database').then(
                m => m.DatabaseComponent
              ),
            title: 'Database Configuration',
            data: supportAccess('config.database.manage'),
          },
          {
            path: 'configuration/cache-settings',
            loadComponent: () =>
              import('./features/super-admin/configuration/cache-settings/cache').then(
                m => m.CacheSettingsComponent
              ),
            title: 'Cache Settings',
            data: supportAccess('config.manage.cache'),
          },
          {
            path: 'configuration/settings',
            loadComponent: () =>
              import('./features/super-admin/configuration/cookie-settings/cookie').then(
                m => m.CookieSettingsComponent
              ),
            title: 'Cookie Settings',
            data: supportAccess('config.manage.cookie'),
          },
          {
            path: 'configuration/cookie-settings',
            redirectTo: 'configuration/settings',
            pathMatch: 'full',
          },

          {
            path: 'configuration/sms',
            loadComponent: () =>
              import('./features/super-admin/configuration/sms/sms').then(
                m => m.SmsComponent
              ),
            title: 'SMS Configuration',
            data: supportAccess('config.sms.manage'),
          },
          {
            path: 'configuration/email',
            loadComponent: () =>
              import('./features/super-admin/configuration/email/email').then(
                m => m.EmailComponent
              ),
            title: 'Email Configuration',
            data: supportAccess('config.email.manage'),
          },
          {
            path: 'configuration/branding',
            loadComponent: () =>
              import('./features/super-admin/configuration/branding/branding').then(
                m => m.BrandingConfigurationComponent
              ),
            title: 'Branding Configuration',
            data: supportAccess('config.manage.branding'),
          },
          {
            path: 'configuration/email-templates',
            loadComponent: () =>
              import('./features/super-admin/configuration/email-templates/email-templates').then(
                m => m.EmailTemplatesComponent
              ),
            title: 'Email Templates Configuration',
            data: supportAccess('config.manage.email-templates'),
          },
          {
            path: 'configuration/legal-templates',
            loadComponent: () =>
              import('./features/super-admin/configuration/legal-templates/legal-templates').then(
                m => m.LegalTemplatesComponent
              ),
            title: 'Legal Templates Configuration',
            data: supportAccess('config.manage.legal-templates'),
          },
          {
            path: 'configuration/tenant-rights-by-state',
            loadComponent: () =>
              import('./features/super-admin/configuration/tenant-rights-by-state/tenant-rights-by-state').then(
                m => m.TenantRightsByStateComponent
              ),
            title: 'Tenant Rights By State Configuration',
            data: supportAccess('config.manage.legal-templates'),
          },
          {
            path: 'configuration/token-display-names',
            loadComponent: () =>
              import('./features/super-admin/configuration/token-display-names/token-display-names').then(
                m => m.TokenDisplayNamesComponent
              ),
            title: 'Edit Token Display Names',
          },
          {
            path: 'configuration/countries',
            loadComponent: () =>
              import('./features/super-admin/configuration/countries/countries').then(
                m => m.CountriesComponent
              ),
            title: 'Countries Configuration',
            data: supportAccess('config.view.countries'),
          },
          {
            path: 'configuration/upload-documents',
            loadComponent: () =>
              import('./features/super-admin/configuration/upload-documents/upload-documents').then(
                m => m.UploadDocumentsConfigComponent
              ),
            title: 'Upload Documents Configuration',
            data: supportAccess('config.manage.upload-documents'),
          },
          {
            path: 'configuration/permissions',
            loadComponent: () =>
              import('./features/super-admin/configuration/permissions/permissions').then(
                m => m.PermissionsComponent
              ),
            title: 'Permissions Configuration',
            data: supportAccess('config.permissions.manage'),
          },
          {
            path: 'configuration/docusign',
            loadComponent: () =>
              import('./features/super-admin/configuration/docusign/docusign').then(
                m => m.DocusignComponent
              ),
            title: 'DocuSign Configuration',
            data: supportAccess('superadmin.manage.docusign'),
          },
          {
            path: 'configuration/renters-insurance',
            loadComponent: () =>
              import('./features/super-admin/configuration/renters-insurance/renters-insurance').then(
                m => m.RentersInsuranceComponent
              ),
            title: 'Renters Insurance Configuration',
            data: supportAccess('config.permissions.manage'),
          },
          {
            path: 'subscriptions/subscription-plans',
            loadComponent: () =>
              import('./features/super-admin/subscriptions/subscription-plans/subscription-plans').then(
                m => m.SubscriptionPlansComponent
              ),
            title: 'Subscription Plans Configuration',
            data: supportAccess('subscriptions.plans.manage'),
          },
          {
            path: 'configuration/reminder-messages',
            loadComponent: () =>
              import('./features/super-admin/configuration/reminder-messages/reminder-messages').then(
                m => m.ReminderMessagesComponent
              ),
            title: 'Reminder Messages Configuration',
            data: supportAccess('config.permissions.manage'),
          },
          {
            path: 'configuration/announcements',
            loadComponent: () =>
              import('./features/super-admin/configuration/announcements/announcements').then(
                m => m.AnnouncementsComponent
              ),
            title: 'Announcements Configuration',
            data: supportAccess('config.manage.announcements'),
          },
          {
            path: 'configuration/seo',
            loadComponent: () =>
              import('./features/super-admin/configuration/seo/seo').then(
                m => m.SeoConfigurationComponent
              ),
            title: 'SEO Configuration',
            data: supportAccess('config.manage.seo'),
          },
          {
            path: 'configuration/support',
            loadComponent: () =>
              import('./features/super-admin/configuration/support/support').then(
                m => m.SupportConfigurationComponent
              ),
            title: 'Support Configuration',
          },
          {
            path: 'subscriptions/features',
            loadComponent: () =>
              import('./features/super-admin/subscriptions/features/features').then(
                m => m.FeaturesComponent
              ),
            title: 'Plan Features Configuration',
            data: supportAccess('subscriptions.features.manage'),
          },
          {
            path: 'subscriptions/plans',
            loadComponent: () =>
              import('./features/super-admin/subscriptions/plans/plans').then(
                m => m.PlansComponent
              ),
            title: 'Plan Limits Configuration',
            data: supportAccess('subscriptions.limits.manage'),
          },
          {
            path: 'subscriptions/subscription-list',
            loadComponent: () =>
              import('./features/super-admin/subscriptions/subscription-list/subscription-list').then(
                m => m.SubscriptionListComponent
              ),
            title: 'Subscription List',
            data: supportAccess('subscriptions.list.view'),
          },
          {
            path: 'subscriptions/pricing-tiers',
            loadComponent: () =>
              import('./features/super-admin/subscriptions/plan-pricingTier/plan-pricingTier').then(
                m => m.PlanPricingTierComponent
              ),
            title: 'Pricing Tiers Configuration',
            data: supportAccess('subscriptions.pricing.manage'),
          },
          {
            path: 'subscriptions/fee-configuration',
            loadComponent: () =>
              import('./features/super-admin/subscriptions/feeconfiguration/feeconfiguration').then(
                m => m.FeeConfigurationComponent
              ),
            title: 'Fee Configuration',
            data: supportAccess('subscriptions.fees.manage'),
          },
          {
            path: 'properties/all',
            loadComponent: () =>
              import('./features/property/view/view').then(
                m => m.ViewPropertiesComponent
              ),
            title: 'All Properties',
            data: supportAccess('properties.view.all'),
          },
          {
            path: 'properties/add',
            loadComponent: () =>
              import('./features/property/create/create').then(
                m => m.CreatePropertyComponent
              ),
            title: 'Add Property',
            data: supportAccess('properties.create'),
          },
          {
            path: 'create-property',
            redirectTo: 'properties/add',
            pathMatch: 'full',
          },
          {
            path: 'properties/bulk-upload',
            loadComponent: () =>
              import('./features/property/bulk-upload/bulk-upload').then(
                m => m.BulkPropertyUploadComponent
              ),
            title: 'Bulk Property Upload',
          },
          {
            path: 'bulk-property-upload',
            redirectTo: 'properties/bulk-upload',
            pathMatch: 'full',
          },
          {
            path: 'properties/available-units',
            loadComponent: () =>
              import('./features/super-admin/properties/available-units/available-units').then(
                m => m.AvailableUnitsComponent
              ),
            title: 'Available Units',
            data: supportAccess('properties.view.all'),
          },
          {
            path: 'tenants/all',
            loadComponent: () =>
              import('./features/super-admin/tenants/tenants').then(
                m => m.SuperAdminTenantsComponent
              ),
            title: 'All Tenants',
            data: supportAccess('tenants.view.all'),
          },

          {
            path: 'tenants/add',
            loadComponent: () =>
              import('./features/super-admin/user-add/user-add.component').then(
                m => m.UserAddComponent
              ),
            title: 'Add Tenant',
            data: supportAccess('tenants.create'),
          },
          {
            path: 'tenants/applications',
            loadComponent: () =>
              import('./features/super-admin/applications/applications').then(
                m => m.SuperAdminApplicationsComponent
              ),
            title: 'Tenant Applications',
            data: supportAccess('tenants.applications.view'),
          },
          {
            path: 'payments/overdue',
            loadComponent: () =>
              import('./features/super-admin/payments/overdue/overdue').then(
                m => m.OverduePaymentsComponent
              ),
            title: 'Overdue Payments',
            data: supportAccess('payments.view.overdue'),
          },
          {
            path: 'maintenance',
            loadComponent: () =>
              import('./features/landlord/maintenance/maintenace/maintenance').then(
                m => m.MaintenanceComponent
              ),
            title: 'Maintenance',
          },
          {
            path: 'maintenance/new-request',
            loadComponent: () =>
              import('./features/landlord/maintenance/new-request/new-request').then(
                m => m.NewRequestComponent
              ),
            title: 'New Maintenance Request',
          },
          {
            path: 'maintenance/tenant-requests',
            loadComponent: () =>
              import('./features/landlord/maintenance/tenantrequests/tenantrequests').then(
                m => m.TenantRequestsComponent
              ),
            title: 'Tenant Maintenance Requests',
          },
          {
            path: 'maintenance/emergency',
            loadComponent: () =>
              import('./features/super-admin/maintenance/emergency/emergency').then(
                m => m.EmergencyComponent
              ),
            title: 'Emergency Maintenance',
            data: supportAccess('maintenance.view.emergency'),
          },
          {
            path: 'maintenance/all',
            loadComponent: () =>
              import('./features/super-admin/maintenance/all/all-requests').then(
                m => m.AllMaintenanceRequestsComponent
              ),
            title: 'All Maintenance Requests',
            data: supportAccess('maintenance.view.all'),
          },
          {
            path: 'maintenance/vendors/all',
            loadComponent: () =>
              import('./features/super-admin/vendors/vendors').then(
                m => m.VendorsComponent
              ),
            title: 'All Vendors',
            data: supportAccess('maintenance.view.vendors'),
          },
          {
            path: 'maintenance/new-vendor',
            loadComponent: () =>
              import('./features/landlord/maintenance/new-vendor/new-vendor').then(
                m => m.NewVendorComponent
              ),
            title: 'Add New Vendor',
          },
          {
            path: 'maintenance/property-details/:id',
            loadComponent: () =>
              import('./features/landlord/property-details/property-details').then(
                m => m.PropertyDetailsComponent
              ),
            title: 'Property Details',
          },

          {
            path: 'analytics/financial',
            loadComponent: () =>
              import('./features/super-admin/financial-reports/reports').then(
                m => m.FinancialReportsComponent
              ),
            title: 'Financial Reports',
          },
          {
            path: 'analytics/occupancy',
            loadComponent: () =>
              import('./features/super-admin/occupancy-report/report').then(
                m => m.OccupancyReportsComponent
              ),
            title: 'Occupancy Report',
          },
          {
            path: 'analytics/maintenance',
            loadComponent: () =>
              import('./features/super-admin/maintenance-analytics/report').then(
                m => m.MaintenanceAnalyticsComponent
              ),
            title: 'Maintenance Analytics',
          },
          {
            path: 'monitoring/error-logs',
            loadComponent: () =>
              import('./features/super-admin/error-logs/error-logs').then(
                m => m.ErrorLogsComponent
              ),
            title: 'Error Logs',
            data: supportAccess('config.manage.error-code'),
          },
          {
            path: 'leases/invoices',
            loadComponent: () =>
              import('./features/super-admin/invoices/invoices').then(
                m => m.InvoicesComponent
              ),
            title: 'Invoices',
            data: supportAccess('leases.invoices.view'),
          },
          {
            path: 'property-detail/:id',
            loadComponent: () =>
              import('./features/property/detail/detail').then(
                m => m.PropertyDetailComponent
              ),
            title: 'Property Detail',
          },
        ],
      },
      {
        path: 'rma-admin-internal',
        loadComponent: () =>
          import('./features/rma-admin/rma-admin').then(
            m => m.RmaAdminInternalComponent
          ),
        title: 'RMA Admin Internal',
        data: { role: 'admin' },
      },
      {
        path: 'tenant',
        loadComponent: () =>
          import('./shared/layout/generic/generic-layout.component').then(
            m => m.GenericLayoutComponent
          ),
        data: { role: 'tenant' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/dashboard/tenant/tenant').then(
                m => m.TenantDashboardComponent
              ),
            title: 'Tenant Dashboard',
          },
          {
            path: 'invoices',
            loadComponent: () =>
              import('./features/tenant/lease/invoices/invoice').then(
                m => m.InvoicesComponent
              ),
            title: 'Invoices',
          },
          {
            path: 'leases',
            loadComponent: () =>
              import('./features/tenant/lease/my-leases/my-leases').then(
                m => m.MyLeasesComponent
              ),
            title: 'My Leases',
          },
          {
            path: 'leases/documents',
            loadComponent: () =>
              import('./features/tenant/documents/documents').then(
                m => m.TenantDocumentsComponent
              ),
            title: 'Lease Documents',
          },
          {
            path: 'settings/display',
            loadComponent: () =>
              import('./features/tenant/display/display').then(
                m => m.DisplayComponent
              ),
            title: 'Display Settings',
          },
          {
            path: 'mailbox',
            loadComponent: () =>
              import('./features/mailbox/mailbox').then(
                m => m.MailboxComponent
              ),
            title: 'Mailbox',
          },
          {
            path: 'messages',
            loadComponent: () =>
              import('./features/tenant/messages/messages').then(
                m => m.TenantMessagesComponent
              ),
            title: 'Messages',
          },
          {
            path: 'calendar',
            loadComponent: () =>
              import('./features/tenant/calendar/calendar').then(
                m => m.TenantCalendarComponent
              ),
            title: 'Calendar',
          },
          {
            path: 'properties/view-all',
            loadComponent: () =>
              import('./features/tenant/properties/view-all').then(
                m => m.TenantPropertiesComponent
              ),
            title: 'Browse Properties',
          },
          // Commented out - now handled by tabs in main leases component
          // {
          //   path: 'leases/documents',
          //   loadComponent: () => import('./features/tenant/documents/documents').then(m => m.TenantDocumentsComponent),
          //   title: 'Lease Documents'
          // },
          // {
          //   path: 'leases/my-leases',
          //   loadComponent: () => import('./features/tenant/lease/my-leases/my-leases').then(m => m.MyLeasesComponent),
          //   title: 'My Leases'
          // },
          {
            path: 'view-properties',
            loadComponent: () =>
              import('./features/property/view/view').then(
                m => m.ViewPropertiesComponent
              ),
            title: 'View Properties',
          },
          {
            path: 'properties/all',
            redirectTo: 'view-properties',
            pathMatch: 'full',
          },
          {
            path: 'profile',
            loadComponent: () =>
              import('./features/profile/profile').then(
                m => m.UserProfileComponent
              ),
            title: 'Profile',
          },
          {
            path: 'settings',
            children: [
              {
                path: 'profile',
                loadComponent: () =>
                  import('./features/profile/profile').then(
                    m => m.UserProfileComponent
                  ),
                title: 'Profile Settings',
              },
              {
                path: 'referral',
                loadComponent: () =>
                  import('./features/referral/referral').then(
                    m => m.ReferralDashboardComponent
                  ),
                title: 'Referral Dashboard',
              },
              {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'maintenance',
            children: [
              {
                path: 'submit-request',
                loadComponent: () =>
                  import('./features/tenant/maintenance/submit-request/submit-request').then(
                    m => m.SubmitRequestComponent
                  ),
                title: 'Submit Maintenance Request',
              },
              {
                path: 'my-request',
                loadComponent: () =>
                  import('./features/tenant/maintenance/my-request/my-request').then(
                    m => m.MyRequestComponent
                  ),
                title: 'My Maintenance Requests',
              },
              {
                path: 'submit-vendor',
                loadComponent: () =>
                  import('./features/tenant/maintenance/submit-vendor/submit-vendor').then(
                    m => m.SubmitVendorComponent
                  ),
                title: 'Submit Maintenance Request To Vendor',
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'my-request',
              },
            ],
          },
          {
            path: 'payments',
            loadComponent: () =>
              import('./features/tenant/payments/pay/pay-rent').then(
                m => m.PayRentComponent
              ),
            title: 'Pay Rent',
          },
          // Commented out - now handled by tabs in main payments component
          // {
          //   path: 'payments/pay',
          //   loadComponent: () => import('./features/tenant/payments/pay/pay-rent').then(m => m.PayRentComponent),
          //   title: 'Pay Rent'
          // },
          {
            path: 'payments/history',
            loadComponent: () =>
              import('./features/tenant/payments/history/payment-history').then(
                m => m.PaymentHistoryComponent
              ),
            title: 'Payment History',
          },
          {
            path: 'statements/profit-loss',
            loadComponent: () =>
              import('./features/tenant/statements/profit-loss/tenant-profit-loss').then(
                m => m.TenantProfitLossComponent
              ),
            title: 'Statement',
          },
          {
            path: 'reviews',
            loadComponent: () =>
              import('./features/reviews/reviews').then(
                m => m.ReviewsComponent
              ),
            title: 'Landlord Reviews',
            data: { reviewMode: 'tenant' },
          },
          {
            path: 'testimonials',
            loadComponent: () =>
              import('./features/testimonials/testimonials').then(
                m => m.TestimonialsComponent
              ),
            title: 'Tenant Testimonials',
            data: { testimonialMode: 'tenant' },
          },
        ],
      },
      {
        path: 'landlord',
        loadComponent: () =>
          import('./shared/layout/generic/generic-layout.component').then(
            m => m.GenericLayoutComponent
          ),
        title: 'Landlord Dashboard',
        data: { role: 'landlord' },
        children: [
          // Stepper route for landlord dashboard (with sidenavbar)
          {
            path: 'property/:propertyId/stepper',
            loadChildren: () =>
              import('./features/property/stepper/stepper').then(
                m => m.default
              ),
            title: 'Legal Document Stepper',
          },
          {
            path: '',
            loadComponent: () =>
              import('./features/dashboard/landlord/landlord').then(
                m => m.LandlordDashboardComponent
              ),
            title: 'Landlord Dashboard',
          },
          {
            path: 'payments/all',
            loadComponent: () =>
              import('./features/super-admin/payments/all/all-payments').then(
                m => m.AllPaymentsComponent
              ),
            title: 'All Payments',
          },
          {
            path: 'create-property',
            loadComponent: () =>
              import('./features/property/create/create').then(
                m => m.CreatePropertyComponent
              ),
            title: 'Create Property',
          },
          {
            path: 'bulk-property-upload',
            loadComponent: () =>
              import('./features/property/bulk-upload/bulk-upload').then(
                m => m.BulkPropertyUploadComponent
              ),
            title: 'Bulk Property Upload',
          },
          {
            path: 'view-properties',
            loadComponent: () =>
              import('./features/property/view/view').then(
                m => m.ViewPropertiesComponent
              ),
            title: 'View Properties',
          },
          {
            path: 'property-detail/:id',
            loadComponent: () =>
              import('./features/property/detail/detail').then(
                m => m.PropertyDetailComponent
              ),
            title: 'Property Detail',
          },
          {
            path: 'rental-management',
            loadComponent: () =>
              import('./features/landlord/rental-management/rental-management').then(
                m => m.RentalManagementComponent
              ),
            title: 'Rental Management',
          },
          {
            path: 'tenant-management',
            loadComponent: () =>
              import('./features/landlord/tenant-management/tenant-management').then(
                m => m.TenantManagementComponent
              ),
            title: 'Tenant Management',
          },
          {
            path: 'property-management',
            loadComponent: () =>
              import('./features/landlord/property-management/property-management').then(
                m => m.PropertyManagementComponent
              ),
            title: 'Property Management',
          },
          {
            path: 'property-manager',
            loadComponent: () =>
              import('./features/landlord/property-manager/property-manager').then(
                m => m.PropertyManagerComponent
              ),
            title: 'Property Manager',
          },
          {
            path: 'property-owner',
            loadComponent: () =>
              import('./features/landlord/property-owner/property-owner').then(
                m => m.PropertyOwnerComponent
              ),
            title: 'Manage Property Owner',
          },
          {
            path: 'available-units',
            loadComponent: () =>
              import('./features/landlord/available-units/available-units').then(
                m => m.AvailableUnitsComponent
              ),
            title: 'Available Units',
          },
          {
            path: 'profile',
            loadComponent: () =>
              import('./features/profile/profile').then(
                m => m.UserProfileComponent
              ),
            title: 'Profile',
          },
          {
            path: 'settings',
            children: [
              {
                path: 'profile',
                loadComponent: () =>
                  import('./features/profile/profile').then(
                    m => m.UserProfileComponent
                  ),
                title: 'Profile Settings',
              },
              {
                path: 'referral',
                loadComponent: () =>
                  import('./features/referral/referral').then(
                    m => m.ReferralDashboardComponent
                  ),
                title: 'Referral Dashboard',
              },
              {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'stripe',
            children: [
              {
                path: 'onboarding',
                loadComponent: () =>
                  import('./features/landlord/stripe/onboarding/stripe-onboarding.component').then(
                    m => m.StripeOnboardingComponent
                  ),
                title: 'Payment Setup',
              },
              {
                path: 'complete',
                loadComponent: () =>
                  import('./features/landlord/stripe/complete/stripe-complete.component').then(
                    m => m.StripeCompleteComponent
                  ),
                title: 'Setup Complete',
              },
              {
                path: 'refresh',
                redirectTo: 'onboarding',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'account-list',
            loadComponent: () =>
              import('./features/dashboard/landlord/account-list/account-list.component').then(
                m => m.AccountListComponent
              ),
            title: 'Account List',
          },
          {
            path: 'financial',
            loadComponent: () =>
              import('./features/financial/financial-dashboard.component').then(
                m => m.FinancialDashboardComponent
              ),
            title: 'Financial Dashboard',
          },
          {
            path: 'transactions',
            loadComponent: () =>
              import('./features/landlord/all/all-payments').then(
                m => m.LandlordPaymentsComponent
              ),
            title: 'Transactions',
          },
          {
            path: 'reports',
            loadComponent: () =>
              import('./features/landlord/reports/reports').then(
                m => m.ReportsComponent
              ),
            title: 'Reports',
          },
          {
            path: 'reports/profit-loss',
            loadComponent: () =>
              import('./features/landlord/reports/profit-loss/profit-loss').then(
                m => m.ProfitLossComponent
              ),
            title: 'Profit & Loss',
          },
          {
            path: 'reports/net-cash-flow',
            loadComponent: () =>
              import('./features/landlord/reports/net-cash-flow/net-cash-flow').then(
                m => m.NetCashFlowComponent
              ),
            title: 'Net Cash Flow Report',
          },
          {
            path: 'reports/income-statement',
            loadComponent: () =>
              import('./features/landlord/reports/income-statement/income-statement').then(
                m => m.IncomeStatementComponent
              ),
            title: 'Income Statement Report',
          },
          {
            path: 'reports/general-ledger',
            loadComponent: () =>
              import('./features/landlord/reports/general-ledger/general-ledger').then(
                m => m.GeneralLedgerComponent
              ),
            title: 'General Ledger Report',
          },
          {
            path: 'reports/financial-reports',
            loadComponent: () =>
              import('./features/landlord/reports/financial-reports/financial-reports').then(
                m => m.FinancialReportsComponent
              ),
            title: 'Financial Reports',
          },
          {
            path: 'reports/maintenance',
            loadComponent: () =>
              import('./features/landlord/reports/maintenance/maintenance').then(
                m => m.MaintenanceReportsComponent
              ),
            title: 'Maintenance Reports',
          },
          {
            path: 'reports/occupancy',
            loadComponent: () =>
              import('./features/landlord/reports/occupancy/occupancy').then(
                m => m.OccupancyReportsComponent
              ),
            title: 'Occupancy Reports',
          },
          {
            path: 'all-tenants',
            loadComponent: () =>
              import('./features/landlord/tenants/all-tenants/all-tenants').then(
                m => m.AllTenantsComponent
              ),
            title: 'All Tenants',
          },
          {
            path: 'tenants/all',
            loadComponent: () =>
              import('./features/landlord/tenants/all-tenants/all-tenants').then(
                m => m.AllTenantsComponent
              ),
            title: 'All Tenants',
          },
          {
            path: 'tenants/applications',
            loadComponent: () =>
              import('./features/landlord/tenants/applications/applications').then(
                m => m.TenantApplicationsComponent
              ),
            title: 'Applications',
          },
          {
            path: 'reviews',
            loadComponent: () =>
              import('./features/reviews/reviews').then(
                m => m.ReviewsComponent
              ),
            title: 'Tenant Reviews',
            data: { reviewMode: 'landlord' },
          },
          {
            path: 'testimonials',
            loadComponent: () =>
              import('./features/testimonials/testimonials').then(
                m => m.TestimonialsComponent
              ),
            title: 'Landlord Testimonials',
            data: { testimonialMode: 'landlord' },
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import('./features/landlord/notification/notification').then(
                m => m.NotificationComponent
              ),
            title: 'Notifications',
          },
          {
            path: 'leases',
            children: [
              {
                path: '',
                redirectTo: 'all',
                pathMatch: 'full',
              },
              {
                path: 'all',
                loadComponent: () =>
                  import('./features/landlord/leases/all-leases/all-leases').then(
                    m => m.AllLeasesComponent
                  ),
                title: 'All Leases',
              },
              {
                path: 'active',
                loadComponent: () =>
                  import('./features/landlord/leases/active-leases/active-leases').then(
                    m => m.ActiveLeasesComponent
                  ),
                title: 'Active Leases',
              },
              {
                path: 'expire',
                loadComponent: () =>
                  import('./features/landlord/leases/expire/expire').then(
                    m => m.ExpireLeasesComponent
                  ),
                title: 'Expiring & Expired Leases',
              },
            ],
          },
          // Maintenance route for landlord: direct to property-management, all dropdowns/options commented out
          {
            path: 'maintenance',
            loadComponent: () =>
              import('./features/landlord/maintenance/maintenace/maintenance').then(
                m => m.MaintenanceComponent
              ),
            title: 'Maintenance',
          },
          {
            path: 'maintenance/new-request',
            loadComponent: () =>
              import('./features/landlord/maintenance/new-request/new-request').then(
                m => m.NewRequestComponent
              ),
            title: 'New Maintenance Request',
          },
          {
            path: 'maintenance/all',
            loadComponent: () =>
              import('./features/landlord/maintenance/all-requests/all-requests').then(
                m => m.AllRequestsComponent
              ),
            title: 'All Maintenance Requests',
          },
          {
            path: 'maintenance/tenant-requests',
            loadComponent: () =>
              import('./features/landlord/maintenance/tenantrequests/tenantrequests').then(
                m => m.TenantRequestsComponent
              ),
            title: 'Tenant Maintenance Requests',
          },
          {
            path: 'maintenance/emergency',
            loadComponent: () =>
              import('./features/landlord/maintenance/emergency/emergency').then(
                m => m.EmergencyComponent
              ),
            title: 'Emergency Maintenance Requests',
          },
          {
            path: 'maintenance/vendors',
            loadComponent: () =>
              import('./features/landlord/maintenance/vendors/vendors').then(
                m => m.VendorsComponent
              ),
            title: 'Vendor Management',
          },
          {
            path: 'maintenance/new-vendor',
            loadComponent: () =>
              import('./features/landlord/maintenance/new-vendor/new-vendor').then(
                m => m.NewVendorComponent
              ),
            title: 'Add New Vendor',
          },
          {
            path: 'maintenance/property-details/:id',
            loadComponent: () =>
              import('./features/landlord/property-details/property-details').then(
                m => m.PropertyDetailsComponent
              ),
            title: 'Property Details',
          },
          {
            path: 'documents',
            loadComponent: () =>
              import('./features/landlord/documents/documents').then(
                m => m.LandlordDocumentsComponent
              ),
            title: 'Documents Management',
          },
          {
            path: 'landlord-forms',
            loadComponent: () =>
              import('./features/landlord/landord-forms/landlord-forms').then(
                m => m.LandlordFormsComponent
              ),
            title: 'Landlord Forms',
          },
          {
            path: 'e-signatures',
            loadComponent: () =>
              import('./features/landlord/e-signatures/e-signatures').then(
                m => m.LandlordESignaturesComponent
              ),
            title: 'E-Signatures',
          },
          {
            path: 'rent-collection',
            loadComponent: () =>
              import('./features/landlord/rent-collection/rent-collection').then(
                m => m.RentCollectionComponent
              ),
            title: 'Rent Collection',
          },
          {
            path: 'financial/add-bank-account',
            loadComponent: () =>
              import('./shared/components/plaid-integration/plaid-integration.component').then(
                m => m.PlaidIntegrationComponent
              ),
            title: 'Add Bank Account',
          },
          {
            path: 'financial/all-bank-accounts',
            loadComponent: () =>
              import('./features/dashboard/landlord/account-list/account-list.component').then(
                m => m.AccountListComponent
              ),
            title: 'All Bank Accounts',
          },
          {
            path: 'accept-lease',
            loadComponent: () =>
              import('./features/landlord/accept-lease/accept-lease').then(
                m => m.AcceptApplicationComponent
              ),
            title: 'Accept Application & Add Lease Terms',
          },
          {
            path: 'invoices',
            loadComponent: () =>
              import('./features/landlord/leases/invoices/invoice').then(
                m => m.InvoicesComponent
              ),
            title: 'Invoices',
          },
          {
            path: 'messages',
            loadComponent: () =>
              import('./features/landlord/messages/messages').then(
                m => m.LandlordMessagesComponent
              ),
            title: 'Messages',
          },
          {
            path: 'settings/display',
            loadComponent: () =>
              import('./features/landlord/display/display').then(
                m => m.DisplayComponent
              ),
            title: 'Display Settings',
          },
          {
            path: 'calendar',
            loadComponent: () =>
              import('./features/landlord/calendar/calendar').then(
                m => m.CalendarComponent
              ),
            title: 'Calendar',
          },
          {
            path: 'mailbox',
            loadComponent: () =>
              import('./features/mailbox/mailbox').then(
                m => m.MailboxComponent
              ),
            title: 'Mailbox',
          },
          {
            path: 'analytics/financial-reports',
            loadComponent: () =>
              import('./features/landlord/analytics/financial-reports/financial-reports').then(
                m => m.FinancialReportsComponent
              ),
            title: 'Financial Reports',
          },
          // Withdraw routes
          {
            path: 'withdraw',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/landlord/withdraw/withdraw-request/withdraw-request').then(
                    m => m.WithdrawRequestComponent
                  ),
                title: 'Withdraw Request',
              },
              {
                path: 'history',
                loadComponent: () =>
                  import('./features/landlord/withdraw/withdraw-history/withdraw-history').then(
                    m => m.WithdrawHistoryComponent
                  ),
                title: 'Withdraw History',
              },
            ],
          },
          // Tenant Screening routes
          {
            path: 'tenant-screening',
            children: [
              {
                path: '',
                redirectTo: 'create-request',
                pathMatch: 'full',
              },
              {
                path: 'create-request',
                loadComponent: () =>
                  import('./features/landlord/tenant-screening/create-request/create-request').then(
                    m => m.CreateScreeningRequestComponent
                  ),
                title: 'Create Screening Request',
              },
              {
                path: 'view-requests',
                loadComponent: () =>
                  import('./features/landlord/tenant-screening/view-requests/view-requests').then(
                    m => m.ViewScreeningRequestsComponent
                  ),
                title: 'View Screening Requests',
              },
              {
                path: 'view-reports',
                loadComponent: () =>
                  import('./features/landlord/tenant-screening/view-reports/view-reports').then(
                    m => m.ViewScreeningReportsComponent
                  ),
                title: 'View Screening Reports',
              },
            ],
          },
          {
            path: 'analytics/occupancy-reports',
            loadComponent: () =>
              import('./features/landlord/analytics/occupancy-reports/occupancy-reports').then(
                m => m.OccupancyReportsComponent
              ),
            title: 'Occupancy Reports',
          },
          {
            path: 'analytics/maintenance',
            loadComponent: () =>
              import('./features/landlord/analytics/maintenance-analytics/maintenance-analytics').then(
                m => m.MaintenanceAnalyticsComponent
              ),
            title: 'Maintenance Analytics',
          },
          {
            path: 'reports',
            redirectTo: 'reports/net-cash-flow',
            pathMatch: 'full',
          },
          {
            path: 'reports/net-cash-flow',
            loadComponent: () =>
              import('./features/landlord/reports/net-cash-flow/net-cash-flow').then(
                m => m.NetCashFlowComponent
              ),
            title: 'Net Cash Flow Report',
          },
          {
            path: 'reports/income-statement',
            loadComponent: () =>
              import('./features/landlord/reports/income-statement/income-statement').then(
                m => m.IncomeStatementComponent
              ),
            title: 'Income Statement Report',
          },
          {
            path: 'reports/general-ledger',
            loadComponent: () =>
              import('./features/landlord/reports/general-ledger/general-ledger').then(
                m => m.GeneralLedgerComponent
              ),
            title: 'General Ledger Report',
          },
          {
            path: 'reports/financial-reports',
            loadComponent: () =>
              import('./features/landlord/reports/financial-reports/financial-reports').then(
                m => m.FinancialReportsComponent
              ),
            title: 'Financial',
          },
          {
            path: 'reports/maintenance',
            loadComponent: () =>
              import('./features/landlord/reports/maintenance/maintenance').then(
                m => m.MaintenanceReportsComponent
              ),
            title: 'Maintenance',
          },
          {
            path: 'reports/occupancy',
            loadComponent: () =>
              import('./features/landlord/reports/occupancy/occupancy').then(
                m => m.OccupancyReportsComponent
              ),
            title: 'Occupancy',
          },
        ],
      },
      {
        path: 'vendor',
        loadComponent: () =>
          import('./shared/layout/generic/generic-layout.component').then(
            m => m.GenericLayoutComponent
          ),
        data: { role: 'vendor' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/dashboard/vendor/vendor').then(
                m => m.VendorDashboardComponent
              ),
            title: 'Vendor Dashboard',
          },
          {
            path: 'profile',
            loadComponent: () =>
              import('./features/profile/profile').then(
                m => m.UserProfileComponent
              ),
            title: 'Profile',
          },
          {
            path: 'view-maintenance-requests',
            loadComponent: () =>
              import('./features/dashboard/vendor/view-maintenance-requests/view-maintenance-requests').then(
                m => m.ViewMaintenanceRequestsComponent
              ),
            title: 'View Maintenance Requests',
            data: { permission: 'vendor.view.maintenance' },
          },
          {
            path: 'track-maintenance-requests',
            loadComponent: () =>
              import('./features/dashboard/vendor/track-maintenance-requests/track').then(
                m => m.TrackMaintenanceRequestsComponent
              ),
            title: 'Track Maintenance Requests',
            data: { permission: 'vendor.manage.maintenance' },
          },
          {
            path: 'mailbox',
            loadComponent: () =>
              import('./features/mailbox/mailbox').then(
                m => m.MailboxComponent
              ),
            title: 'Mailbox',
          },
          {
            path: 'settings',
            children: [
              {
                path: 'profile',
                loadComponent: () =>
                  import('./features/profile/profile').then(
                    m => m.UserProfileComponent
                  ),
                title: 'Profile Settings',
              },
              {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full',
              },
            ],
          },
        ],
      },
      {
        path: 'dashboard/leases/documents',
        redirectTo: 'dashboard/tenant/leases/documents',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'landlord/accept-lease',
    loadComponent: () =>
      import('./features/landlord/accept-lease/accept-lease').then(
        m => m.AcceptApplicationComponent
      ),
    title: 'Accept Application & Add Lease Terms',
  },
  {
    path: 'landlord/stripe/complete',
    loadComponent: () =>
      import('./features/landlord/stripe/complete/stripe-complete.component').then(
        m => m.StripeCompleteComponent
      ),
    title: 'Stripe Setup Complete',
  },
  {
    path: 'mantis',
    loadChildren: () => import('../main.module').then(m => m.MantisModule),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found').then(
        m => m.NotFoundComponent
      ),
  },
];
